import { render, staticRenderFns } from "./EducationalCoursesDetail.vue?vue&type=template&id=3587ba3e&scoped=true&"
import script from "./EducationalCoursesDetail.vue?vue&type=script&lang=js&"
export * from "./EducationalCoursesDetail.vue?vue&type=script&lang=js&"
import style0 from "./EducationalCoursesDetail.vue?vue&type=style&index=0&id=3587ba3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3587ba3e",
  null
  
)

export default component.exports